export const API_URL = process.env.API_URL || '';
export const ENV = process.env.APP_ENV || '';
export const SENTRY_ENV = ENV === 'production' ? 'prod' : ENV;
export const HOST_URL = process.env.HOST_URL || '';
export const IS_PROD = process.env.APP_ENV === 'production';
export const IS_QA = process.env.APP_ENV === 'qa';
export const IS_ETE = process.env.APP_ENV === 'ete';
export const IS_REMOTE = IS_PROD || IS_QA || IS_ETE;
export const IS_LOCAL = !IS_REMOTE;
export const IS_KNOCK_PROD = process.env.KNOCK_ENV === 'production';
export const PRISMATIC_URL = process.env.PRISMATIC_URL || '';
export const COFACTR_ORG_ID =
  process.env.COFACTR_ORG_ID || '251c403d-cfde-4801-97b7-2288e30a164c';
export const COFACTR_SANDBOX_ORG_ID =
  process.env.COFACTR_SANDBOX_ORG_ID || '6b53dd68-ee64-4d7f-8622-385d5f3a0354';
export const BRANDFETCH_CLIENT_ID =
  process.env.BRANDFETCH_CLIENT_ID || '1idC8bMfKAN5L7Uy4xB';
export const GOOGLE_PLACES_API_KEY = process.env.GOOGLE_PLACES_API_KEY || '';
